"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelField = void 0;
const react_1 = __importDefault(require("react"));
const formik_1 = require("formik");
const core_1 = require("@material-ui/core");
const lodash_1 = require("lodash");
const react_2 = require("react");
const LabelComponent = ({ value, placeholder }) => (react_1.default.createElement(core_1.Box, { mt: "4px", mb: "4px" }, value ? value : placeholder));
const LabelField = (_a) => {
    var { name, label, placeholder, displayValueFormat } = _a, rest = __rest(_a, ["name", "label", "placeholder", "displayValueFormat"]);
    const { values } = formik_1.useFormikContext();
    const fieldValue = react_2.useMemo(() => lodash_1.get(values, name), [name, values]);
    const value = react_2.useMemo(() => (typeof displayValueFormat === 'function' ? displayValueFormat(fieldValue, values) : fieldValue), [displayValueFormat, fieldValue]);
    return (react_1.default.createElement(core_1.TextField, Object.assign({}, rest, { id: name, label: label, placeholder: placeholder, fullWidth: true, InputProps: { inputComponent: LabelComponent, disableUnderline: true }, InputLabelProps: { shrink: true, style: { whiteSpace: 'pre' } }, value: value })));
};
exports.LabelField = LabelField;
exports.LabelField.defaultProps = {
    placeholder: '--',
};
//# sourceMappingURL=label-field.js.map